import type { IPath } from '../models';

type TArgs = {
    collapseCount: number;
    collapsed: boolean;
    paths: IPath[];
};

export const getPaths = ({ collapseCount, collapsed, paths }: TArgs) => {
    const { length } = paths;

    return collapsed ? paths.slice(length - collapseCount, length) : paths;
};
